import { _set } from '@felte/common';

function validateSchema(schema, options) {
    function shapeErrors(errors) {
        return errors.inner.reduce((err, value) => {
            /* istanbul ignore next */
            if (!value.path)
                return err;
            return _set(err, value.path, value.message);
        }, {});
    }
    return async function validate(values) {
        return schema
            .validate(values, Object.assign({ strict: true, abortEarly: false }, options))
            .then(() => undefined)
            .catch(shapeErrors);
    };
}
function validator({ schema, level = 'error', castValues, }) {
    return function extender(currentForm) {
        if (currentForm.stage !== 'SETUP')
            return {};
        const validateFn = validateSchema(schema);
        currentForm.addValidator(validateFn, { level });
        if (!castValues)
            return {};
        const transformFn = (values) => {
            return schema.cast(values);
        };
        currentForm.addTransformer(transformFn);
        return {};
    };
}

export { validateSchema, validator };
//# sourceMappingURL=index.mjs.map
